import { atom } from 'recoil';

export const appointmentState = atom({
  key: 'appointmentState',
  default: null,
});
